import { useEffect, useState } from 'react'
import { usePermission } from '@fs/zion-permissions'
import { useQueryParams } from '@fs/zion-router'

const lightyearImageAuditPermissions = ['RMSGroupWritePermission', 'RMSArtifactWritePermission']

export default function useDetermineMode() {
  const {
    query: { mode },
  } = useQueryParams()

  const [hasLightyearRecordsHomePermission, lightyearRecordsHomeCheckStatus] = usePermission(
    'LightyearRecordsHomePermission',
    'LightyearContext'
  )

  const [hasLightyearImageAuditPermission, lightyearImageAuditCheckStatus] = usePermission(
    lightyearImageAuditPermissions,
    'RMSContext'
  )

  const [showMetadataAudit, setShowMetadataAudit] = useState()
  useEffect(() => {
    if (
      lightyearImageAuditCheckStatus === 'loaded' &&
      lightyearRecordsHomeCheckStatus === 'loaded' &&
      typeof setShowMetadataAudit === 'function'
    ) {
      setShowMetadataAudit(
        hasLightyearImageAuditPermission && hasLightyearRecordsHomePermission && mode === 'metadataAudit'
      )
    }
  }, [
    mode,
    setShowMetadataAudit,
    hasLightyearImageAuditPermission,
    lightyearImageAuditCheckStatus,
    hasLightyearRecordsHomePermission,
    lightyearRecordsHomeCheckStatus,
  ])

  const [showImageQualityAudit, setShowImageQualityAudit] = useState()
  useEffect(() => {
    if (typeof setShowImageQualityAudit === 'function') {
      setShowImageQualityAudit(mode === 'imageQualityAudit')
    }
  }, [mode, setShowImageQualityAudit])

  return { showMetadataAudit, showImageQualityAudit }
}
